import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../Component/Header';

function ServicesDetails() {
  const { id, name } = useParams();
  const [services, setServices] = useState([]); // State to store services
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/getproducts/category/${id}`);

        // Handle 404 error (Not Found)
        if (response.status === 404) {
          throw new Error('No products found for the given category ID');
        }

        // Check for other errors
        if (!response.ok) {
          throw new Error(`Error: ${response.status}`);
        }

        const result = await response.json();

        // Handle the "No products found" message from API
        if (result.message && result.message === "No products found for the given category ID") {
          setServices([]); // Set services to empty array if no products found
          setError("No records found");
        } else {

          // Transform the fetched data to match your services structure
          const transformedData = result.products.map((item) => ({
            id: item.product_id,
            image: `${item.product_image}`, // Prepend the image URL from the environment variable
          }));

          setServices(transformedData);
          setError(null); // Clear any previous error
        }
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchServices();
  }, [id]); // Re-run when the `id` changes


  return (
    <div>
      <Header />
      {/* Product Section */}
      <h3 className="text-center" style={{ color: '#000000ff', marginTop: '150px', fontSize: '3rem' }}>
        {name}
      </h3>
      <div className="container p-5">
        {loading ? (
          <div className="text-center">Loading...</div>
        ) : error ? (
          <div className="text-center text-danger">{error}</div>
        ) : services.length === 0 ? (
          <div className="text-center">No records found</div>
        ) : (
          <div
            className="services-grid row g-4"
          >
            {services.map((service) => (
              <div key={service.id} className="col-12 col-md-6 col-lg-4 col-xl-3">
                <div
                  className="service-card bg-light d-flex flex-column"
                  style={{
                    borderRadius: '8px',
                    border: '2px solid #ddd',
                    overflow: 'hidden',
                    width: '100%',
                    height: '100%',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      paddingTop: '100%',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    <img
                      src={service.image}
                      alt={service.name || `service-${service.id}`}
                      loading="lazy"
                      onError={(e) => {
                        e.currentTarget.src = "/placeholder-image.png";
                      }}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        transition: "transform 0.3s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.06)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ServicesDetails;
